export interface SecondaryPanelFrameInput {
  contentTop: number;
  parentTop: number;
  topOffset?: number;
  viewportHeight: number;
  viewportBottomGap: number;
  /** Viewport Y the panel must stay at or below (sticky chrome bottom). */
  viewportTopMin?: number;
}

export interface SecondaryPanelFrame {
  top: number;
  /** Caps the rail so it never grows past the visible viewport. */
  maxHeight: number;
}

/**
 * Desktop rail frame: follow main content top, never climb above sticky chrome,
 * size to the panel's own content, and only cap by remaining viewport.
 */
export const getSecondaryPanelFrame = ({
  contentTop,
  parentTop,
  topOffset = 0,
  viewportHeight,
  viewportBottomGap,
  viewportTopMin = 0,
}: SecondaryPanelFrameInput): SecondaryPanelFrame => {
  const desiredViewportTop = contentTop + topOffset;
  const maxUsefulTopMin = Math.max(0, viewportHeight - viewportBottomGap);
  // Ignore impossible ceilings (e.g. misdetected full-height layout chrome).
  const safeTopMin =
    viewportTopMin > 0 && viewportTopMin < maxUsefulTopMin ? viewportTopMin : 0;
  const clampedViewportTop = Math.max(desiredViewportTop, safeTopMin);

  return {
    top: Math.max(0, clampedViewportTop - parentTop),
    maxHeight: Math.max(0, viewportHeight - clampedViewportTop - viewportBottomGap),
  };
};
